import {observable} from 'mobx';
import moment from 'moment';

class Den {

    @observable public idKlient: number;
    @observable public datum: Date;
    @observable public typ: string;
    @observable public program: number;
    @observable public rozsah: string[];

    public clone(): Den {
        const newDen: Den = new Den();
        newDen.loadFromEntity(this);
        return newDen;
    }

    public loadFromJSON(json: any): Den {
        this.idKlient = json.id;
        this.datum = moment(json.datum).toDate();
        this.typ = json.typ;
        this.program = json.program;
        this.rozsah = json.rozsah;
        return this;
    }

    public loadFromEntity(ent: Den): Den {
        this.idKlient = ent.idKlient;
        this.datum = ent.datum;
        this.typ = ent.typ;
        this.program = ent.program;
        this.rozsah = ent.rozsah;
        return this;
    }

}

export default Den;


// WEBPACK FOOTER //
// ./src/models/Den.tsx